"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserAssignedInTheAproval = exports.getApprovalStatus = exports.updateApprovalItems = exports.groupApprovals = exports.getCurrentCombinedLists = void 0;
exports.getApprovalsCountGroups = getApprovalsCountGroups;
const lodash_1 = __importDefault(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const logger = (0, pino_1.default)({ name: 'approvalsUtils' });
const getCurrentCombinedLists = ({ initialCombinedApprovals }) => {
    return initialCombinedApprovals.sort((a, b) => a.assignedOn - b.assignedOn).reverse();
};
exports.getCurrentCombinedLists = getCurrentCombinedLists;
const groupApprovals = (approvals, isActivityPage) => {
    return approvals.reduce((acc, approval) => {
        const theApprovalStatus = (0, exports.getApprovalStatus)(approval) || '';
        const isPendingRelated = isActivityPage
            ? theApprovalStatus.includes('pending') && theApprovalStatus !== 'forwarded-pending'
            : theApprovalStatus.includes('pending');
        const isCanceledRelated = theApprovalStatus.includes('canceled');
        // we want to group all pending or canceled approvals in one group
        const groupKey = isPendingRelated ? 'pending' : isCanceledRelated ? 'canceled' : theApprovalStatus;
        if (!acc[groupKey]) {
            acc[groupKey] = { approvals: [], count: 0 };
        }
        const approvalStatusGroup = acc[groupKey];
        if (approvalStatusGroup) {
            let updatedApproval = { ...approval };
            switch (groupKey) {
                case 'pending': {
                    updatedApproval = {
                        ...approval,
                        isPending: true,
                        isApproved: false,
                        isDeclined: false,
                        isCancelled: false,
                    };
                    break;
                }
                case 'approved': {
                    updatedApproval = {
                        ...approval,
                        isPending: false,
                        isApproved: true,
                        isDeclined: false,
                        isCancelled: false,
                    };
                    break;
                }
                case 'canceled': {
                    updatedApproval = {
                        ...approval,
                        isPending: false,
                        isApproved: false,
                        isDeclined: false,
                        isCancelled: true,
                    };
                    break;
                }
                case 'declined': {
                    updatedApproval = {
                        ...approval,
                        isPending: false,
                        isApproved: false,
                        isDeclined: true,
                        isCancelled: false,
                    };
                    break;
                }
                default: {
                    break;
                }
            }
            approvalStatusGroup.approvals.push(updatedApproval);
            approvalStatusGroup.count++;
        }
        return acc;
    }, {
        pending: { approvals: [], count: 0 },
        approved: { approvals: [], count: 0 },
        declined: { approvals: [], count: 0 },
        canceled: { approvals: [], count: 0 },
    });
};
exports.groupApprovals = groupApprovals;
const updateApprovalItems = ({ currentCombinedLists, isUserCompanyOrSupportAdmin, teamId, isActivityPage, user, }) => {
    // company admin can see all approvals in dashboard
    // team admin can see all teamapprovals in dashboard, but only approvals that are assigned to them and to him
    // in the approvals pages
    // manager can only seat approvals that are assigned to them in the approvals page
    const approvalsPageCollection = isUserCompanyOrSupportAdmin
        ? currentCombinedLists
        : isActivityPage
            ? currentCombinedLists.filter(approval => approval.request.teamId === teamId)
            : currentCombinedLists
                .filter(approval => approval.request.teamId === teamId)
                .filter(approval => (user?.userId ? lodash_1.default.includes(approval.assignees, user.userId) : false));
    const approvalsDashBoardCollection = isUserCompanyOrSupportAdmin
        ? currentCombinedLists
        : currentCombinedLists.filter(approval => approval.request.teamId === teamId);
    return {
        approvalsPageCollection: lodash_1.default.chain(approvalsPageCollection)
            .uniqBy(function (approvalItem) {
            return approvalItem.subjectId;
        })
            .sortBy(function (approvalItem) {
            return approvalItem.assignedOn;
        })
            .reverse()
            .value(),
        approvalsDashBoardCollection: lodash_1.default.chain(approvalsDashBoardCollection)
            .uniqBy(function (approvalItem) {
            return approvalItem.subjectId;
        })
            .sortBy(function (approvalItem) {
            return approvalItem.assignedOn;
        })
            .reverse()
            .value(),
    };
};
exports.updateApprovalItems = updateApprovalItems;
// approvalStatusLookup is a mapping of: request state + approval outcome -> approval status
const approvalStatusLookup = new Map([
    ['APPROVED,APPROVED', 'approved'],
    ['APPROVED,CARD-CANCELED', 'card-canceled'],
    ['APPROVED,REASSIGNED', 'approved'],
    ['APPROVED,', 'pending'],
    ['REJECTED,REASSIGNED', 'declined'],
    ['REJECTED,REJECTED', 'declined'],
    ['REJECTED,', 'pending'],
    ['SUBMITTED,MANUAL_REASSIGN', 'forwarded-pending'],
    ['SUBMITTED,REASSIGNED', 'forwarded-pending'],
    ['SUBMITTED,SELF-REASSIGNED', 'forwarded-pending'],
    ['SUBMITTED,', 'pending'],
]);
const getApprovalStatus = (approval) => {
    const requestState = approval.request.state;
    const approvalOutcome = approval.outcome;
    let approvalStatus = approvalStatusLookup.get([requestState, approvalOutcome].join(','));
    if (approvalStatus === 'pending' && approval.reassignedByUser != null) {
        approvalStatus = 'pending-forwarded';
    }
    if (!approvalStatus) {
        logger.warn({
            message: `Approval status for approval with id ${approval.id} not found
		for request state ${requestState} and approval outcome ${approvalOutcome}`,
        });
    }
    return approvalStatus || '';
};
exports.getApprovalStatus = getApprovalStatus;
function getApprovalsCountGroups(groupedApprovals, approvalStates) {
    return Object.keys(groupedApprovals).reduce((acc, key) => {
        approvalStates.forEach(state => {
            if (key.includes(state)) {
                const group = groupedApprovals[key];
                if (group) {
                    acc[state] += group.count;
                }
            }
        });
        return acc;
    }, {
        pending: 0,
        approved: 0,
        declined: 0,
        canceled: 0,
    });
}
const isUserAssignedInTheAproval = (userId, approval) => {
    return approval.assignees.includes(userId);
};
exports.isUserAssignedInTheAproval = isUserAssignedInTheAproval;
